export const isAdminAndVisitingAddressSame = (company: server.dto.Company): boolean =>
  (company.address.formatted.every((addressLine, idx) => company.admAddress.formatted[idx] === addressLine)) && company.name === company.admName;

/**
 * @deprecated This should not be used. We should not convert betweend CompanySmall and ArtistSmall instead we should just use ArtistSmall
 **/
export const companyToArtist = (company: server.dto.CompanySmall | server.dto.Company): server.dto.ArtistSmall => {
  if (company == null) return undefined;

  return {
    artistId: company.companyId,
    name: company.name,
  }
}

export const artistToCompany = (artist: server.dto.ArtistSmall): server.dto.CompanySmall => {
  if (artist == null) return undefined;
  return {
    companyId: artist.artistId,
    name: artist.name,
    isValidated: true,
    address: undefined
  }
}

export const toCompanySmall = (company: server.dto.Company): server.dto.CompanySmall => {
  if (company == null) return undefined;

  return {
    companyId: company.companyId,
    name: company.name,
    isValidated: company.isValidated,
    address: company.address
  }
}